var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { IConfigurationRepositoryType, inject, injectable, Observable } from '@serviceos-rn/core';
import { TipConfig } from '../../TipConfig';
import { TipConfiguration } from '../../Domain/DTOs/TipConfigurationDTO';
let TipConfigurationRepository = class TipConfigurationRepository {
    constructor(configurationRepository) {
        this.configurationRepository = configurationRepository;
        this.tipScreenText = new Observable({});
        this.configurationRepository.configuration.observe(this, value => {
            var _a, _b;
            this.tipScreenText.next(((_b = (_a = value[TipConfig.moduleName.toLowerCase()]) === null || _a === void 0 ? void 0 : _a.components) === null || _b === void 0 ? void 0 : _b[TipConfiguration.ComponentNames.tipScreen]) || {});
        });
    }
    getTipScreenText() {
        return this.tipScreenText;
    }
};
TipConfigurationRepository = __decorate([
    injectable({
        type: 'singleton'
    }),
    __param(0, inject(IConfigurationRepositoryType)),
    __metadata("design:paramtypes", [Object])
], TipConfigurationRepository);
export { TipConfigurationRepository };
